/* collection-hero-stage.js
 * <collection-hero-stage> — the Deep Stage collection hero.
 *
 * One job: honor prefers-reduced-motion honestly. The section's CSS hides the
 * <video> and reveals the poster still, but display:none neither stops playback
 * nor the download the `autoplay` attribute already started — so here the
 * attribute is stripped and playback paused. Playback resumes if the user's
 * preference flips back mid-session.
 *
 * Also sets playsInline as belt-and-braces for the `video_tag` render path
 * (the legacy video_url path carries the attribute in markup).
 */
class CollectionHeroStage extends HTMLElement {
  connectedCallback() {
    this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.onMotionChange = this.applyMotionPreference.bind(this);
    this.motionQuery.addEventListener('change', this.onMotionChange);

    const video = this.querySelector('video');
    if (video) video.playsInline = true;
    this.applyMotionPreference();
  }

  disconnectedCallback() {
    if (this.motionQuery) this.motionQuery.removeEventListener('change', this.onMotionChange);
  }

  applyMotionPreference() {
    const video = this.querySelector('video');
    if (!video) return;
    if (this.motionQuery.matches) {
      video.removeAttribute('autoplay');
      video.pause();
    } else if (video.paused) {
      const played = video.play();
      if (played && played.catch) played.catch(() => {});
    }
  }
}

customElements.define('collection-hero-stage', CollectionHeroStage);
